import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'react-redux-app/lib/modules/link/components';

import styles from './styles/index.css.json';


const propTypes = {
  name: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  value: PropTypes.string.isRequired,
  isNegative: PropTypes.bool,
  link: PropTypes.string,
};

const defaultProps = {
  link: null,
  isNegative: false,
};

const BalancePart = ({
  name,
  value,
  link,
  isNegative,
}) => {
  const valueClassName = classnames(
    styles.balancePart__value,
    {
      [styles.balancePart__value_link]: link,
      [styles.balancePart__value_negative]: isNegative,
    }
  );

  return (
    <div className={styles.balancePart}>
      <div className={styles.balancePart__name}>
        {name}
      </div>
      {link ? (
        <Link to={link} className={valueClassName}>{value}</Link>
      ) : (
        <div className={valueClassName}>{value}</div>
      )}
    </div>
  );
};

BalancePart.propTypes = propTypes;
BalancePart.defaultProps = defaultProps;

export default BalancePart;
